import React, { useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ImageSurvey from "../../../../../../medatatheme/assets/images/encuesta.png";

const SurveyModal = () => {
    // TODO: Reactivar el modal "Califica tu experiencia" al terminar todo.
    // Desactivado temporalmente: retornamos null para que no aparezca el popup
    // exit-intent (mouseleave). Para reactivar, eliminar este early return.
    const SURVEY_MODAL_DISABLED = true;

    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const handleMouseLeave = (event) => {
            if (event.clientY <= 0) {
                // Si el mouse sale por la parte superior, mostramos el modal
                setShowModal(true);
            }
        };

        document.addEventListener("mouseleave", handleMouseLeave);

        return () => {
            document.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, []);

    // TODO: Reactivar al terminar todo (quitar esta condición).
    if (SURVEY_MODAL_DISABLED) {
        return null;
    }

    return (
        <Modal className="modalSurvey" isOpen={showModal} backdrop="static" centered>
            <a 
              href="/form/encuesta-de-satisfaccion" 
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/form/encuesta-de-satisfaccion";
              }}
            >
                <img className="img-fluid" src={ImageSurvey} alt="Encuesta Satisfacción" />
            </a>
            <ModalFooter className="modalSurvey">
                <a className="button button-secondary" onClick={() => setShowModal(false)}>
                    Cerrar
                </a>
            </ModalFooter>
        </Modal>
    );
};

export default SurveyModal;